import {useParams, Link} from 'react-router-dom'
import {Space} from 'antd'
import cn from 'clsx'
import styles from './MemberList.module.scss'
import useStore from 'base/store'
import {PermissionType} from 'common/types'
// import {useGetProfile} from 'modules/profile'
import {useOpen} from 'common/hooks'
import {
  Block, Text,
  DotsMenu,
  Button,
  Loader,
  Empty,
  UserAvatar,
  Modal,
  ProfileCircleIcon,
  PenEditThirdIcon, EyeIcon,
  ArrowIcon,
} from 'common/components'
import { /*useGetOrgMember,*/ useGetOrgDetails } from '../'
// import { OrgType } from '../types'
// import TeamMemberForm from './MemberForm'
import TeamMemberForm from './MemberForm'

// const ORG_TYPE_LIST : OrgType[] = ['borrower', 'broker', 'team']

interface MemberBase {
  [propName:string]: any;
}

interface MemberListProps {
  data: any;  // org details
}
export default function MembersList({data: orgData}:MemberListProps) {
  const team = orgData?.users
  if (!team) return <Loader />

  const removedItems = team.filter(
    (user:any) => (user.active === false)
  )
  sortByRole(removedItems)
  const normalItems = team.filter(
    // (user:any) => !['manager', 'associated-manager'].includes(user.role)
    (user:any) => (user.active === true)
  )
  sortByRole(normalItems)

  // console.log(normalItems)
  // console.log(team.map((x:any) => x.role))

  return (
    <Block type="grey" className={styles.root}>
      <MemberGroup title="Active Members"
        items={normalItems} 
        isVCTeam={orgData?.type === 'team'}
      />
      { !!removedItems?.length &&
        <MemberGroup title="Removed Members"  isRemoved
          items={removedItems} 
          isVCTeam={orgData?.type === 'team'}
        />
      }
    </Block>
  )
}

const MemberGroup = ({title, items, isRemoved, isVCTeam}:{
  title:string;
  items:any[];
  isRemoved?:boolean;
  isVCTeam: boolean;
}) => {
  const permissions: PermissionType[] = useStore((state) => state.permissions)
  const params = useParams()
  const {data: resBody} = useGetOrgDetails({
    uuid: params?.uuid
  })

  return (
    !resBody ? null :
    <div className={styles.group}>
      <div className={styles.title}>
        <Text uppercase spacing weight="bold" size="3xs" mb={2}>
          {title}
        </Text>
        { !isRemoved && (
            isVCTeam
            ? !!permissions?.includes('add vc member')
            : !!permissions?.includes('add org member')
          ) &&
          <CreatingAction
            data={resBody?.data}
            projectUuid={''}
            initValue={{}}
            isRequestLoading={false}
          />
        }
      </div>
      { (!items?.length) ?
        <Empty
          icon={<ProfileCircleIcon width={40} height={40} />}
          title="team members"
        />
        :
        <ul className={styles.list}>
          {items.map((user, index:number) => (
            <Member 
              key={index} 
              user={user} 
              isRemoved={isRemoved} 
              isVCTeam={isVCTeam}
              data={resBody?.data}
            />
          ))}
        </ul>
      }
    </div>
  )
}

const Member = ({data: orgData, user, isRemoved, isVCTeam}: {
  data: any
  user: MemberBase
  isRemoved?: boolean
  isVCTeam: boolean
}) => {
  const permissions: PermissionType[] = useStore((state) => state.permissions)
  const isShowMenu = true // profileUuid !== user.uuid && role.coordinator
  // console.log('orgData', orgData)
  // console.log('user.roles', user?.roles)
  const orgRole = user?.roles?.find((r:any) => ((!!r.teamId) && (r.teamId === orgData?.id)) )
  // console.log('orgRole', orgRole)
  const counter = user?.roles?.reduce((accu:any, item:any) => {
    if (!!item?.role) {
      const roleStr = item.role.toLowerCase()
      if (roleStr === 'editor') {
        accu.asEditor += 1
      } else if (roleStr === 'viewer') {
        accu.asViewer += 1
      }
    }
    return accu
  }, { asEditor: 0, asViewer: 0 })

  const member = {
    member: user.uuid,
    roleId: orgRole?.id,
    email : orgRole?.userRole?.email || '',
    phone : orgRole?.userRole?.phone?.slice(3) || '',
    licenseNumber: orgRole?.userRole?.licenseNumber || '',
  }
  return (
    <Block as="li" className={cn(styles.item, !!isRemoved ? styles.removed : undefined)}>
      { isShowMenu && (
          isVCTeam 
          ? !!permissions.includes('edit vc member')
          : !!permissions.includes('edit org member')
        ) &&
        <Menu member={member} data={orgData} />
      }
      <Space className={styles.content} size={12}>
        <UserAvatar size={80} src={user.photo} alt={user.firstName} />
        <div>
          <p className={styles.name}>
            {user.firstName} {user.lastName}
          </p>
          <p className={styles.position}>{
            orgRole?.displayName || 'user role'
          }</p>
          <p className={styles.contacts}>
            <span className={styles.email}>{member.email}</span>
            <br />
            { !!member.phone &&
              <span>+64 {member.phone}</span>
            }
          </p>
        </div>
      </Space>
      <MemberFooter asEditor={counter?.asEditor} asViewer={counter?.asViewer} />
    </Block>
  )
}

const Menu = ({member, data:orgData}: {
  data:any
  member: any
}) => {
  const [isOpen, handleOpen, handleClose] = useOpen()
  return (
    <>
      <DotsMenu className={styles.menu}
        items={[{label: 'Edit', onClick: handleOpen}]}
      />
      <Modal title="Edit team member" open={isOpen} onCancel={handleClose}>
        <TeamMemberForm data={orgData} user={member} onClose={handleClose} />
      </Modal>
    </>
  )
}

const MemberFooter = ({asEditor, asViewer}: {
  asEditor: number
  asViewer: number
}) => {
  return (
    <div className={styles.footer} >
      <Space size={18}>
        <Space className={styles.value} size={6}>
          <EyeIcon />
          <span>{asViewer ?? 0}</span>
        </Space>
        <Space className={styles.value} size={6}>
          <PenEditThirdIcon />
          <span>{asEditor ?? 0}</span>
        </Space>
      </Space>
      <Link className={styles.link} to="/projects" >
        <ArrowIcon className={styles['arrow-icon']} />
      </Link>
    </div>
  )
}

const CreatingAction = ({data: orgData, initValue, projectUuid, isRequestLoading }: {
  data:any
  projectUuid: string
  isRequestLoading: boolean
  initValue: any
}) => {
  const [isOpen, handleOpen, handleClose] = useOpen()
  // console.log(params)
  // console.log(orgData)

  // const orgTypeIndex = Math.floor( Math.random() * ORG_TYPE_LIST.length )
  // const orgType = ORG_TYPE_LIST[orgTypeIndex]
  // console.error('need to use real org type here')
  const orgType = orgData?.type
  // const formTitle = `New ${orgType === 'team' ? 'team ': ''}Member`
  const formTitle = `New ${orgType} Member`

  return (
    !orgData ? null :
    <>
      <Button variant="secondary"
        disabled={isRequestLoading}
        onClick={handleOpen}
      >
        add member
      </Button>
      <Modal title={formTitle} open={isOpen}
        onCancel={handleClose}
      >
        <TeamMemberForm
          data={orgData}
          onClose={handleClose}
        />
      </Modal>
    </>
  )
}

const sortByRole = (users: MemberBase[]) => {
  users.sort((a, b) => (
    (a.role > b.role) ? -1 :
    (a.role < b.role) ? 1 :
    0
  ))
}
